import React, { useEffect, useMemo, useRef, useState } from 'react';
import stamp from '../assets/trincheta-sello-nuevo-transparent.png';
import primeraAsambleaImage from '../assets/cronologia-primera-asamblea.jpg';

const START_DATE = new Date(2023, 11, 30, 20, 55, 0);

function calculateElapsedParts(fromDate, toDate) {
  const start = new Date(fromDate);
  const end = new Date(toDate);

  if (end <= start) {
    return { years: 0, months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  let cursor = new Date(start);
  let years = end.getFullYear() - cursor.getFullYear();
  cursor.setFullYear(cursor.getFullYear() + years);
  if (cursor > end) {
    years -= 1;
    cursor.setFullYear(cursor.getFullYear() - 1);
  }

  let months = 0;
  while (true) {
    const next = new Date(cursor);
    next.setMonth(next.getMonth() + 1);
    if (next <= end) {
      months += 1;
      cursor = next;
    } else {
      break;
    }
  }

  let diffMs = end.getTime() - cursor.getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  diffMs -= days * 1000 * 60 * 60 * 24;
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  diffMs -= hours * 1000 * 60 * 60;
  const minutes = Math.floor(diffMs / (1000 * 60));
  diffMs -= minutes * 1000 * 60;
  const seconds = Math.floor(diffMs / 1000);

  return { years, months, days, hours, minutes, seconds };
}

const timelineItems = [
  { title: 'DIFUSIÓN CONVOCATORIA ABIERTA', date: 'lunes 2 de marzo, 2015', platformImage: 'https://drive.google.com/thumbnail?id=1TIilrHvoX63YePlIuyzWHIh2cZmrnOlo&sz=w2000&v=2' },
  { title: 'PRIMERA ASAMBLEA', date: 'viernes 5 de junio, 2015', platformImage: 'https://drive.google.com/thumbnail?id=17d2E6FNLZTGsSbhM8QWeQ9I7Q946bn9x&sz=w2000', imageTop: '-10%' },
  { title: 'HITO 03', date: 'Fecha por definir', platformImage: 'https://drive.google.com/thumbnail?id=1rxriz8wGnNHrvcJL3xMWtPFtKhLN_a6B&sz=w2000', imageWidth: 'min(320px, 36vw)' },
  { title: 'HITO 04', date: 'Fecha por definir', platformImage: 'https://drive.google.com/thumbnail?id=1rqhtDeXP5dsk5ChLiqcp4iFSAAopjTiZ&sz=w2000', imageWidth: 'min(320px, 36vw)' },
  { title: 'HITO 05', date: 'Fecha por definir', platformImage: 'https://drive.google.com/thumbnail?id=1M1t-CwtEcWk7w19PnPZ7eekBbqaZckw1&sz=w2000', imageWidth: 'min(320px, 36vw)' },
  { title: 'HITO 06', date: 'Fecha por definir', platformImage: 'https://drive.google.com/thumbnail?id=1gAOBaqzgpqTOk7PUKyVUVOLBq_B1nDnm&sz=w2000', imageWidth: 'min(320px, 36vw)' },
  { title: 'CONSTITICIÓN LEGAL', date: 'miércoles 6 de abril, 2016', platformImage: 'https://drive.google.com/thumbnail?id=10NF8NZLby-OL81LBSoCfyyP37ZL1qssA&sz=w2000', imageWidth: 'min(320px, 36vw)' },
  { title: 'HITO 08', date: 'Fecha por definir' },
  { title: 'HITO 09', date: 'Fecha por definir' },
  { title: 'HITO 10', date: 'Fecha por definir' },
  { title: 'HITO 11', date: 'Fecha por definir' },
  { title: 'HITO 12', date: 'Fecha por definir' },
  { title: 'HITO 13', date: 'Fecha por definir' },
  { title: 'HITO 14', date: 'Fecha por definir' },
  { title: '100º ASAMBLEA', date: 'lunes 22 de mayo, 2017' },
  { title: 'HITO 16', date: 'Fecha por definir' },
  { title: 'HITO 17', date: 'Fecha por definir' },
  { title: 'Asamblea #344, Decisión de pasar a Período de Hibernación', date: 'lunes 6 de junio, 2022', platformImage: 'https://drive.google.com/thumbnail?id=1QAZBTuORj8vZ3W0pb03DajTVf_xAjQHj&sz=w2000' },
  { title: 'Asamblea #400, Entrada en vigor del Periodo de Hibernación', date: 'viernes 29 diciembre, 2023', platformImage: 'https://drive.google.com/thumbnail?id=1Q200n1I2chPmISune7zmicWhQ7RuFEnX&sz=w2000' },
  { title: 'PERIODO DE HIBERNACIÓN', date: 'AA-MM-DD · HH;MM;SS', isRunningClock: true },
];

const ClockPart = ({ value, label }) => (
  <span className="guasasapoCronologiaPage__clockPart">
    <span className="guasasapoCronologiaPage__clockValue">{value}</span>
    <span className="guasasapoCronologiaPage__clockLabel">{label}</span>
  </span>
);

const ClockDisplay = ({ elapsed }) => (
  <span className="guasasapoCronologiaPage__clockDisplay" aria-label="Años, meses, días, horas, minutos y segundos">
    <ClockPart value={String(elapsed.years).padStart(2, '0')} label="AA" />
    <span className="guasasapoCronologiaPage__clockSep">-</span>
    <ClockPart value={String(elapsed.months).padStart(2, '0')} label="MM" />
    <span className="guasasapoCronologiaPage__clockSep">-</span>
    <ClockPart value={String(elapsed.days).padStart(2, '0')} label="DD" />
    <span className="guasasapoCronologiaPage__clockSep guasasapoCronologiaPage__clockSep--dot">·</span>
    <span className="guasasapoCronologiaPage__clockGap" />
    <ClockPart value={String(elapsed.hours).padStart(2, '0')} label="HH" />
    <span className="guasasapoCronologiaPage__clockSep">;</span>
    <ClockPart value={String(elapsed.minutes).padStart(2, '0')} label="MM" />
    <span className="guasasapoCronologiaPage__clockSep">;</span>
    <ClockPart value={String(elapsed.seconds).padStart(2, '0')} label="SS" />
  </span>
);

const GuasasapoCronologia = () => {
  const maxIndex = timelineItems.length - 1;
  const [position, setPosition] = useState(maxIndex);
  const [now, setNow] = useState(() => new Date());
  const [fadeKey, setFadeKey] = useState(0);
  const [spinTurn, setSpinTurn] = useState(0);
  const [platformBaseAngle, setPlatformBaseAngle] = useState(35);
  const previousPositionRef = useRef(maxIndex);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    setFadeKey((value) => value + 1);
  }, [position]);

  useEffect(() => {
    const previous = previousPositionRef.current;
    const delta = position - previous;

    if (delta !== 0) {
      setSpinTurn((value) => value + Math.abs(delta));
      previousPositionRef.current = position;
      return undefined;
    }

    previousPositionRef.current = position;
    return undefined;
  }, [position]);

  const activeItem = useMemo(() => timelineItems[position], [position]);
  const progress = maxIndex > 0 ? (position / maxIndex) * 100 : 0;
  const elapsed = useMemo(() => calculateElapsedParts(START_DATE, now), [now]);
  const platformTransform = `translate(-50%, -50%) perspective(1200px) rotateX(58deg) rotateZ(${platformBaseAngle}deg) rotateY(${spinTurn}turn) scaleX(2.7)`;
  const platformTransformMd = `translate(-50%, -50%) perspective(1200px) rotateX(58deg) rotateZ(${platformBaseAngle}deg) rotateY(${spinTurn}turn) scaleX(2.45)`;
  const platformTransformSm = `translate(-50%, -50%) perspective(1200px) rotateX(58deg) rotateZ(${platformBaseAngle}deg) rotateY(${spinTurn}turn) scaleX(2.25)`;

  const goStart = () => setPosition(0);
  const goEnd = () => setPosition(maxIndex);
  const goPrev = () => setPosition((value) => Math.max(0, value - 1));
  const goNext = () => setPosition((value) => Math.min(maxIndex, value + 1));

  return (
    <div className="guasasapoCronologiaPage">
      <header className="guasasapoCronologiaPage__header">
        <a href="/guasasapo" className="guasasapoCronologiaPage__back" aria-label="Volver atrás">←</a>
        <img src={stamp} alt="Guasasapo" className="guasasapoCronologiaPage__stamp" />
      </header>

      <main className="guasasapoCronologiaPage__main">
        <div className="guasasapoCronologiaPage__board">
          <div className="guasasapoCronologiaPage__planeWrap">
            <div className="guasasapoCronologiaPage__plane" aria-label="Plataforma central">
              {activeItem.platformImage ? (
                <div
                  className="guasasapoCronologiaPage__platformArtworkWrap"
                  key={activeItem.platformImage}
                  style={{
                    '--platform-artwork-offset-y': activeItem.imageOffsetY || '0px',
                    '--platform-artwork-baseline': activeItem.imageBaseline || '43%',
                    '--platform-artwork-width': activeItem.imageWidth || 'min(236px, 27.5vw)',
                  }}
                >
                  <img src={activeItem.platformImage} alt={activeItem.title} className="guasasapoCronologiaPage__platformArtwork" />
                </div>
              ) : null}
              <div
                className="guasasapoCronologiaPage__platformTop"
                style={{
                  '--platform-transform': platformTransform,
                  '--platform-transform-md': platformTransformMd,
                  '--platform-transform-sm': platformTransformSm,
                }}
              />
            </div>
          </div>

          <div className="guasasapoCronologiaPage__timelineSection">
            <div className="guasasapoCronologiaPage__timelineMeta">
              <div key={fadeKey} className="guasasapoCronologiaPage__timelineActiveInfo">
                <span className="guasasapoCronologiaPage__timelineCurrent">{activeItem.title}</span>
                <span className={`guasasapoCronologiaPage__timelineDate ${activeItem.isRunningClock ? 'is-clock' : ''}`}>
                  {activeItem.isRunningClock ? <ClockDisplay elapsed={elapsed} /> : activeItem.date}
                </span>
              </div>
            </div>

            <div className="guasasapoCronologiaPage__timelineControls">
              <button type="button" className="guasasapoCronologiaPage__timelineButton" onClick={goStart} aria-label="Ir al inicio">{'<<'}</button>
              <button type="button" className="guasasapoCronologiaPage__timelineButton" onClick={goPrev} aria-label="Retroceder un hito">{'<'}</button>

              <div className="guasasapoCronologiaPage__timelineSliderWrap">
                <div className="guasasapoCronologiaPage__timelineRail" />
                <div className="guasasapoCronologiaPage__timelineFill" style={{ width: `${progress}%` }} />
                <div className="guasasapoCronologiaPage__timelineKnob" style={{ left: `${progress}%` }} />
                <input
                  type="range"
                  min="0"
                  max={maxIndex}
                  step="1"
                  value={position}
                  onChange={(e) => setPosition(Number(e.target.value))}
                  className="guasasapoCronologiaPage__timelineSlider"
                  aria-label="Línea de tiempo Guasasapo"
                />
              </div>

              <button type="button" className="guasasapoCronologiaPage__timelineButton" onClick={goNext} aria-label="Avanzar un hito">{'>'}</button>
              <button type="button" className="guasasapoCronologiaPage__timelineButton" onClick={goEnd} aria-label="Ir al final">{'>>'}</button>
            </div>

            <div className="guasasapoCronologiaPage__milestones" aria-label="Hitos de la cronología">
              {timelineItems.map((item, index) => {
                const isActive = index === position;

                return (
                  <button
                    type="button"
                    key={`${item.title}-${index}`}
                    className={`guasasapoCronologiaPage__milestone ${isActive ? 'is-active' : ''}`}
                    onClick={() => setPosition(index)}
                    aria-label={item.title}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default GuasasapoCronologia;
